<template lang="html">
  <div class="edit-site-visibility tier tier-three">
    <Tooltip
      content="Disable the lock screen to allow public access to your website"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <SiteVisibilityForm
        @submit="submitSite"
        v-model="site"
        :errors="errors"
      />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteVisibilityForm from '@/components/forms/SiteVisibilityForm'
import Tooltip from '@/components/Tooltip'

export default {
  name: 'EditSite',

  components: {
    SiteVisibilityForm,
    Tooltip
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} visibility`
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'visibility settings', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
